module.exports = __webpack_public_path__ + "1.4.15-unryo/img/step1.3d36be9d.png";